import { useMemo } from 'react'
import { GetProgramLevelFromHashmap } from 'functions/programLevelUtils'

import MesoVolumeConfigDisplay from 'components/Program/MesoVolumeConfig/MesoVolumeConfigDisplay'

const DISPLAY_MESO_VOLUME_PROGRAM_LEVEL_SCORE_RANGE = false

export default function MesoVolume({ programMetadata = null, mesoVolume = null }) {

    const programLevelHashMap = programMetadata?.programLevelHashMap ?? {}
    const macroVolumeFocusTypeHashMap = programMetadata?.macroVolumeFocusTypeHashMap ?? {}

    const programLevel = mesoVolume?.programLevelId != null ? programLevelHashMap[mesoVolume.programLevelId] : null
    const macroVolumeFocusType = mesoVolume?.macroVolumeFocusTypeId != null ? macroVolumeFocusTypeHashMap[mesoVolume.macroVolumeFocusTypeId] : null
    const programLevelScoreLowerBound = Number(mesoVolume?.programLevelScoreLowerBound ?? 0)
    const programLevelScoreUpperBound = Number(mesoVolume?.programLevelScoreUpperBound ?? 0)
    const mesoVolumeProgramLevel = useMemo(() => GetProgramLevelFromHashmap(programLevelHashMap, programLevelScoreUpperBound), [programLevelHashMap, programLevelScoreUpperBound])
    
    if (mesoVolume == null) return null

    return (
        <div 
            className='p-4 w-full min-w-0 space-y-4 cursor-pointer border border-gray-300 rounded-lg'
            onClick={() => {
                const url = `/mesoVolume/${mesoVolume.mesoVolumeId}`
                window.open(url, '_blank')
            }}
        >
            <div className='flex items-center gap-x-2'>
                <p className='text-center truncate pl-1'>
                    {mesoVolume.name}
                </p>
            </div>

            <div>
                <div className='flex flex-wrap items-center gap-x-2 -mt-2'>
                    {macroVolumeFocusType &&
                        <div className='flex justify-center'>
                            <span className='inline-flex items-center gap-x-1.5 rounded-full border border-gray-300 px-3 py-1 text-xxs font-medium text-gray-700'>
                                <span
                                    className='h-3 w-3 flex-shrink-0 rounded-full'
                                    style={{ backgroundColor: macroVolumeFocusType.colorHex }}
                                />
                                {macroVolumeFocusType.name}
                            </span>
                        </div>
                    }

                    {programLevel &&
                        <div className='flex justify-center'>
                            <span className='inline-flex items-center gap-x-1.5 rounded-full border border-gray-300 px-3 py-1 text-xxs font-medium text-gray-700'>
                                <span
                                    className='h-3 w-3 flex-shrink-0 rounded-full'
                                    style={{ backgroundColor: programLevel.colorHex }}
                                />
                                {programLevel.name}-{mesoVolume.level ?? 'Unknown'}
                            </span>
                        </div>
                    }
                </div>
            </div>

            <MesoVolumeConfigDisplay 
                programMetadata={programMetadata}
                mode='view'
                mesoVolumeConfig={mesoVolume} 
            />

            {/* 
            {mesoVolume?.description?.length === 0 && 
                <div className='h-16 bg-gray-100 rounded-lg flex items-center justify-center'>
                    <p className='text-sm text-center text-gray-400'>
                        No description
                    </p>
                </div>
            } 
            */}

            {/* 
            {mesoVolume.description.length > 0 && 
                <div className='h-16 overflow-y-scroll bg-gray-100 rounded-lg webkit-scrollbar-hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
                    <p className='px-3 py-2 text-sm text-left text-gray-600'>
                        {mesoVolume.description}
                    </p>
                </div>
            } 
            */}

            {DISPLAY_MESO_VOLUME_PROGRAM_LEVEL_SCORE_RANGE && (
                <div
                    className='w-full rounded-full py-1 px-4'
                    style={{
                        backgroundColor: mesoVolumeProgramLevel?.colorHex,
                    }}
                >
                    <p className='text-xxs text-center'>
                        {programLevelScoreLowerBound}-{programLevelScoreUpperBound}</p>
                </div>
            )}
        </div>
    )
}